export enum UserTxType {
  APPROVE = "approve",
  FUND_MOVR = "fund-movr",
  CLAIM = "claim",
  DEX_SWAP = "dex-swap",
  SIGN = "sign",
}
